require('./ctxTagsInput.style.scss');

class ctxTagsInputController {
    constructor($scope, $element, $timeout) {
        this.$element = $element;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.slidePosition = { index: 0, offset: 0 };
        this.filteredTags = [];
        this.$scope.$watch(() => this.filterFlag, flag => {
            if(!flag) return;
            this.filteredTags = this.getFilterTags('filterBy');
            this.slideTag(null, true);
        });
    }

    tagRemoved(tagId) {
        let id = tagId.split('=')[0],
            option = tagId.split('=')[1];
        this.remove(this.tags.filter(tag => tag.filterKey === id)[0], option);
        this.setSlideProperty();
    }

    removeAllTags() {
        this.tags.forEach(tag => (!tag.defaultValue) ? this.remove(tag, null, true) : '');
        this.onRemove();
        this.slidePosition = { index: 0, offset: 0 };
        this.filteredTags = this.getFilterTags('filterBy');
    }

    remove(tag, option, all) {
        if(tag.defaultValue) return;
        (!option) ? tag.clear() : tag.clearOption(option);
        if(!all) {
            this.onRemove();
            if(option) this.slideTag(-1);
            this.filteredTags = this.getFilterTags('filterBy');
        }
    }

    canSlide(i) {
        let tagElements, tagElementsLength, tagItemsWidth = 0, pos, overflowDetected, tagsInput, closeAll, tagsInputWidth, tagsCloseWidth, available;
        tagElements = this.$element.find('.scroll-handle ctx-tag');
        tagElementsLength = tagElements.length;
        tagElements.each(function () { tagItemsWidth += $(this).outerWidth(); });
        pos = this.slidePosition.index + i;
        tagsInput = this.$element.find('.tags-input')[0];
        closeAll = this.$element.find('.close-all')[0];
        if(!tagsInput && !closeAll) return;
        tagsInputWidth = tagsInput.offsetWidth;
        tagsCloseWidth = closeAll ? closeAll.offsetWidth : 0;
        available = tagsInputWidth - tagsCloseWidth;
        overflowDetected = tagItemsWidth > available;
        return (pos >= 0 && pos < tagElementsLength) && (overflowDetected || (i < 0 && !overflowDetected));
    }

    slideTag(i, firstTag) {
        this.$timeout(() => {
            if((firstTag && !this.slidePosition.index) || (!firstTag && !this.canSlide(i))) {
                this.setSlideProperty();
                return;
            }
            if(firstTag) {
                this.slidePosition = { index: 0, offset: 0 };
            } else {
                const nextPos = i > 0 ? this.slidePosition.index + i : this.slidePosition.index;
                const width = this.$element.find('.scroll-handle ctx-tag').eq(nextPos - 1).width();
                this.slidePosition.index += i;
                if(!this.slidePosition.index) this.slidePosition.offset = 0;
                else this.slidePosition.offset += -i * width;
            }
            this.$element.find('.scroll-handle').css('transform', `translateX(${this.slidePosition.offset}px)`);
            this.setSlideProperty();
        }, 0);
    }

    getFilterTags(property) {
        return this.tags.filter(tag => angular.isDefined(tag[property]) && tag[property] !== '' && tag[property].length !== 0);
    }

    setSlideProperty() {
        this.$timeout(() => {
            this.canSlidePrevious = this.canSlide(-1);
            this.canSlideNext = this.canSlide(1);
        }, 0);
    }
}

ctxTagsInputController.$inject = ['$scope', '$element', '$timeout'];

const ctxTagsInputComponent = {
    controller: ctxTagsInputController,
    template: require('./ctxTagsInput.template.html'),
    scope: {},
    bindings: {
        tags: '=',
        onRemove: '&',
        filterFlag: '=',
        filteredTags: '=?',
        alwaysVisible: '<?'
    }
};

module.exports = ctxTagsInputComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTagsInput/ctxTagsInput.component.js